export const Text = ({ children, className, as, ...rest }) => {
  const Component = as || 'span'
  return (
    <Component
      className={`font-light ${
        className || 'text-gray-50'
      }`}
      {...rest}
    >
      {children}
    </Component>
  )
}

export const Subtext = ({ children, className, as, ...rest }) => {
  const Component = as || 'span'
  return (
    <Component
      className={`text-sm font-light ${
        className || 'text-gray-50'
      }`}
      {...rest}
    >
      {children}
    </Component>
  )
}
